// Guest texts for samwise's /guest/waitlist_* error codes
export const WAITLIST_ERRORS: Record<string, string> = {
  'waitlist_not_enabled': 'Det finns ingen väntelista här just nu.',
  'guest_queue_not_enabled': 'Det går inte att ställa sig i kön här.',
  'invalid_party_size': 'Välj hur många ni är.',
  'party_size_too_small': 'Sällskapet är för litet.',
  'party_size_too_large': 'Sällskapet är för stort.',
  'name_required': 'Fyll i ditt namn.',
  'phone_required': 'Fyll i ditt mobilnummer.',
  'contact_required': 'Fyll i mobilnummer eller e-post så att vi kan nå dig.',
  'invalid_date': 'Datumet går inte att bevaka.',
  'invalid_time_window': 'Välj en tid där från är före till och som inte redan har passerat.',
  'invalid_booking_type': 'Den här bokningstypen går inte att bevaka.',
  'entry_not_found': 'Vi hittar inte din plats i väntelistan. Kontrollera länken.',
  'not_active': 'Din plats i väntelistan är redan avslutad.',
  'not_offered': 'Du har inte fått något bord erbjudet än.',
  'slot_taken': 'Tiden hann tyvärr bokas av någon annan. Du står kvar på bevakningen och får ett nytt SMS om något annat blir ledigt.',
  'invalid_answer': 'Något gick fel. Försök igen.',
};
